import { clientActionTypes } from './client.types';
import http from '../../services/http';
import { getCompany, updateCompany } from '../company/company.actions';
import { toast } from 'react-toastify';

export const selectCurrentClient = state => state.clients.currentClient;
export const selectClients = state => state.clients.clients;
export const selectCurrentClientValidated = state => state.clients.currentClientValidated;

export const setCurrentClient = client => {
    return {
        type: clientActionTypes.SET_CURRENT_CLIENT,
        payload: client
    }
};

export const setClients = clients => {
    return {
        type: clientActionTypes.SET_CLIENTS,
        payload: clients
    }
};

export const setCurrentClientValidated = client => {
    return {
        type: clientActionTypes.SET_CURRENT_CLIENT_VALIDATED,
        payload: client
    }
};

export const getClients = () => {
    return async dispatch => {
        try {
            const response = await http.get(`/clients`);
            const data = response.data;

            if (data === false) {
                dispatch(setClients(false));
                dispatch(setCurrentClientValidated(true));
            } else {
                dispatch(setClients(data));
            }
        } catch (error) {
            console.log(error);
        }
    };
};


export const getClientById = id => {
    return async dispatch => {
        try {
            const response = await http.get(`/clients/${id}`);
            const data = response.data;

            if (data.length === 0) {
                dispatch(setCurrentClient(false));
                dispatch(setCurrentClientValidated(true));
            } else {
                dispatch(setCurrentClient(data));
            }
        } catch (error) {
            console.log(error);
        }
    };
};

const translateFields = (data) => {
    const translationMap = {
        'razao': 'business_name',
        'cnpj': 'cnpj',
        'endereco': 'address',
        'numero': 'number',
        'bairro': 'district',
        'cidade': 'city',
        'estado': 'state',
        'cep': 'zip_code',
        'email': 'email',
        'ddd': 'area_code',
        'telefone': 'phone',
        'ativo': 'active',
        'grupoAtendimento': 'service_group',
        'grupoAtendimentoDesc': 'service_group_description',
        'produtoDesc': 'product_description',
        'versaoUso': 'version_in_use',
        'modulosAtivos': 'active_modules',
        'nome': 'name',
        'dataSincWS': 'sync_date'
    };

    const translatedData = {};
    for (const [key, value] of Object.entries(data)) {
        const translatedKey = translationMap[key] || key;
        translatedData[translatedKey] = value;
    }

    return translatedData;
};

const isCompanyDataEqual = (company1, company2) => {
    company2.code = parseInt(company2.code, 10);
    const keys1 = Object.keys(company1);
    const keys2 = Object.keys(company2);

    const commonKeys = keys1.filter(key => keys2.includes(key));

    for (let key of commonKeys) {
        if (company1[key] !== company2[key]) {
            console.log(company1[key], company2[key])
            return false;
        }
    }
    return true;
};

export const validateClient = async (clientName, clientEmail, clientCode) => {
    try {
        const response = await http.post(`/clients/validate-client`, {
            name: clientName,
            email: clientEmail,
            code: clientCode
        });
        return response.data;
    } catch (error) {
        console.error('Erro na validação do cliente:', error);
        return false;
    }
};

export const updateClient = (client, code) => {
    return async (dispatch, getState) => {
        try {
            const data = await validateClient(client.name, client.email, code);

            if (!data) {
                console.log('Cliente não existe');
                dispatch(setCurrentClientValidated(false));
                return;
            }

            dispatch(setCurrentClientValidated(true));

            if (client.company_id !== null) {
                const translatedResponseData = translateFields({
                    ...data, code: code, id: client.company.id,
                    updated_at: client.company.updated_at, created_at: client.company.created_at,
                    status: client.company.status
                });

                if (!isCompanyDataEqual(client.company, translatedResponseData)) {
                    console.log("Dados da empresa atualizados: ", translatedResponseData);
                    dispatch(getCompany({ ...data, code: code }, client)).then(() => {
                        const company = getState().companies.company;
                        if (company && company.id) {
                            console.log("Empresa encontrada e associada ao cliente: ", company);
                            dispatch(updateClientWithCompany(client, company.id));
                        }
                    })
                } else {
                    dispatch(updateCompany(translatedResponseData, code));
                }
            } else {
                console.log("Empresa não associada ao cliente.");
                dispatch(getCompany({ ...data, code: code }, client)).then(() => {
                    const company = getState().companies.company;
                    if (company && company.id) {
                        console.log("Empresa encontrada e associada ao cliente: ", company);
                        dispatch(updateClientWithCompany(client, company.id));
                    }
                });
            }
        } catch (error) {
            console.error(error);
        }
    };
};

export const updateClientWithCompany = (client, companyId) => {
    return async dispatch => {
        try {
            console.log(companyId)
            const updateResponse = await http.put(`/clients/${client.id}`, { name: client.name, email: client.email, company_id: companyId });
            dispatch(getClientById(updateResponse.data.id));
            dispatch(setCurrentClientValidated(true));
        } catch (error) {
            console.log(error);
        }
    }
};